import React from 'react';
import { Routes, Route, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FiLogOut, FiHome, FiSettings } from 'react-icons/fi';
import BannersManagement from './components/BannersManagement';
import BrandsManagement from './components/BrandsManagement';
import ProductsManagement from './components/ProductsManagement';
import LogosManagement from './components/LogosManagement';
import HeaderImagesManagement from './components/HeaderImagesManagement';
import FooterImagesManagement from './components/FooterImagesManagement';
import HeroImagesManagement from './components/HeroImagesManagement'; // Importar el nuevo componente
import InstagramReelsManagement from './components/InstagramReelsManagement';
import UsersManagement from './components/UsersManagement';
import ConfigurationManagement from './components/ConfigurationManagement';
import './Backoffice.css';

const Backoffice = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="backoffice">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>IMDI Backoffice</h2>
          <p className="user-info">Usuario: {user?.username} ({user?.role})</p>
        </div>
        <nav className="sidebar-nav">
          <Link to="/backoffice/banners" className={`nav-item ${location.pathname === '/backoffice/banners' ? 'active' : ''}`}>
            Banners
          </Link>
          <Link to="/backoffice/brands" className={`nav-item ${location.pathname === '/backoffice/brands' ? 'active' : ''}`}>
            Marcas
          </Link>
          <Link to="/backoffice/products" className={`nav-item ${location.pathname === '/backoffice/products' ? 'active' : ''}`}>
            Productos
          </Link>
          <Link to="/backoffice/logos" className={`nav-item ${location.pathname === '/backoffice/logos' ? 'active' : ''}`}>
            Logos
          </Link>
          <Link to="/backoffice/header-images" className={`nav-item ${location.pathname === '/backoffice/header-images' ? 'active' : ''}`}>
            Imágenes Header
          </Link>
          <Link to="/backoffice/footer-images" className={`nav-item ${location.pathname === '/backoffice/footer-images' ? 'active' : ''}`}>
            Imágenes Footer
          </Link>
          <Link to="/backoffice/hero-images" className={`nav-item ${location.pathname === '/backoffice/hero-images' ? 'active' : ''}`}>
            Fondos de Título (Hero)
          </Link>
          <Link to="/backoffice/instagram-reels" className={`nav-item ${location.pathname === '/backoffice/instagram-reels' ? 'active' : ''}`}>
            Instagram Reels
          </Link>
          {user?.role === 'admin' && (
            <Link to="/backoffice/users" className={`nav-item ${location.pathname === '/backoffice/users' ? 'active' : ''}`}>
              Usuarios
            </Link>
          )}
          <Link to="/backoffice/configuration" className={`nav-item ${location.pathname === '/backoffice/configuration' ? 'active' : ''}`}>
            <FiSettings /> Configuración
          </Link>
        </nav>
        <div className="sidebar-footer">
          <Link to="/" className="nav-item">
            <FiHome /> Volver al sitio
          </Link>
          <button onClick={handleLogout} className="logout-btn">
            <FiLogOut /> Cerrar Sesión
          </button>
        </div>
      </aside>
      <main className="backoffice-content">
        <Routes>
          <Route path="banners" element={<BannersManagement />} />
          <Route path="brands" element={<BrandsManagement />} />
          <Route path="products" element={<ProductsManagement />} />
          <Route path="logos" element={<LogosManagement />} />
          <Route path="header-images" element={<HeaderImagesManagement />} />
          <Route path="footer-images" element={<FooterImagesManagement />} />
          <Route path="hero-images" element={<HeroImagesManagement />} /> {/* Nueva ruta */}
          <Route path="instagram-reels" element={<InstagramReelsManagement />} />
          <Route path="users" element={<UsersManagement />} />
          <Route path="configuration" element={<ConfigurationManagement />} />
          <Route path="*" element={<DefaultDashboard />} />
        </Routes>
      </main>
    </div>
  );
};

const DefaultDashboard = () => {
  return (
    <div className="dashboard">
      <h1>Panel de Administración</h1>
      <p>Selecciona una sección del menú lateral para comenzar.</p>
    </div>
  );
};

export default Backoffice;
